import {
  HttpClient,
} from "@angular/common/http";

import {
  inject,
  Injectable,
} from "@angular/core";

import {
  Observable,
} from "rxjs";

import {
  BBPS_AccountHistory as BBPS_AccountHistory_URL,
  BBPS_Biller_FetchBill,
  BBPS_Biller_GetOperators,
  BBPS_CreditCard_GetBill,
  BBPS_CreditCard_GetOperatorList,
  BBPS_InitiateRecharge as BBPS_InitiateRecharge_URL,

  BBPS_GetMobileOperator as
    BBPS_GetMobileOperator_URL,

  BBPS_GetPrepaidPlan as
    BBPS_GetPrepaidPlan_URL,

  BBPS_GetPrepaidPlanByName as
    BBPS_GetPrepaidPlanByName_URL,
} from "src/app/GlobalVariable";

import {
  BbpsAccountHistoryApiResponseDTO,
  BbpsAccountHistoryRequestDTO,
  BbpsBillApiResponseDTO,
  BbpsFetchBillRequestDTO,
  BbpsInitiateRechargeRequestDTO,
  BbpsInitiateRechargeResponseDTO,
  BbpsOperatorApiResponseDTO,
  BbpsOperatorRequestDTO,
  GetMobileOperatorRequestDTO,
  MobileOperatorApiResponseDTO,
  PrepaidPlanApiResponseDTO,
  PrepaidPlanByNameRequestDTO,
  PrepaidPlanRequestDTO,
} from "./biller-operator-interface";

@Injectable({
  providedIn: "root",
})
export class BillerOperatorService {
  private readonly http =
    inject(HttpClient);

  BBPS_GetMobileOperator(
    data: GetMobileOperatorRequestDTO,
  ): Observable<MobileOperatorApiResponseDTO> {
    const mobileNumber = String(
      data?.mobileNumber ?? "",
    ).trim();

    const requestUrl =
      `${BBPS_GetMobileOperator_URL}/` +
      encodeURIComponent(mobileNumber);

    return this.http.get<
      MobileOperatorApiResponseDTO
    >(requestUrl);
  }

  /** Existing code/key-based method retained. */
  BBPS_GetPrepaidPlan(
    data: PrepaidPlanRequestDTO,
  ): Observable<PrepaidPlanApiResponseDTO> {
    return this.http.post<
      PrepaidPlanApiResponseDTO
    >(
      BBPS_GetPrepaidPlan_URL,
      data,
    );
  }

  /** POST /BBPS/REH/GetPrepaidPlanByName */
  BBPS_GetPrepaidPlanByName(
    data: PrepaidPlanByNameRequestDTO,
  ): Observable<PrepaidPlanApiResponseDTO> {
    return this.http.post<
      PrepaidPlanApiResponseDTO
    >(
      BBPS_GetPrepaidPlanByName_URL,
      data,
    );
  }

  /**
   * Creates the recharge intent and returns rechargeId + PRRN before Razorpay.
   * POST /BBPS/REH/InitiateRecharge
   */
  BBPS_InitiateRecharge(
    data: BbpsInitiateRechargeRequestDTO,
  ): Observable<BbpsInitiateRechargeResponseDTO> {
    return this.http.post<
      BbpsInitiateRechargeResponseDTO
    >(
      BBPS_InitiateRecharge_URL,
      data,
    );
  }

  /**
   * Loads the logged-in user's BBPS/recharge transaction history.
   * POST /BBPS/BFR/AccountHistory
   * Payload: { userId }
   */
  BBPS_AccountHistory(
    data: BbpsAccountHistoryRequestDTO,
  ): Observable<BbpsAccountHistoryApiResponseDTO> {
    return this.http.post<
      BbpsAccountHistoryApiResponseDTO
    >(
      BBPS_AccountHistory_URL,
      data,
    );
  }

  BBPS_GetBillerOperators(
    data: BbpsOperatorRequestDTO,
  ): Observable<BbpsOperatorApiResponseDTO> {
    return this.http.post<
      BbpsOperatorApiResponseDTO
    >(
      BBPS_Biller_GetOperators,
      data,
    );
  }

  BBPS_GetCreditCardOperators(
    data: BbpsOperatorRequestDTO,
  ): Observable<BbpsOperatorApiResponseDTO> {
    return this.http.post<
      BbpsOperatorApiResponseDTO
    >(
      BBPS_CreditCard_GetOperatorList,
      data,
    );
  }

  BBPS_FetchBill(
    data: BbpsFetchBillRequestDTO,
  ): Observable<BbpsBillApiResponseDTO> {
    return this.http.post<
      BbpsBillApiResponseDTO
    >(
      BBPS_Biller_FetchBill,
      data,
    );
  }

  BBPS_GetCreditCardBill(
    data: BbpsFetchBillRequestDTO,
  ): Observable<BbpsBillApiResponseDTO> {
    return this.http.post<
      BbpsBillApiResponseDTO
    >(
      BBPS_CreditCard_GetBill,
      data,
    );
  }
}
